import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { SorCode } from "@app/models/rest/sor-code";

@Injectable({
  providedIn: "root"
})
export class SorCodeRestService extends HateoasResourceOperation<SorCode> {
  constructor() {
    super(SorCode);
  }
}
